<div class="header-banner" [ngClass]="type">
  <app-info-banner class="info" [banner]="banner" [type]="type" [style]="style"></app-info-banner>
  <img class="banner-img" src="../../../assets/img/{{banner?.image.url }}" alt="{{ banner?.image.alt }}">
</div>
